"use client";
import Link from "next/link";
import "./footer.css";
import { usePathname } from "next/navigation";
import { useState } from "react";

export default function AsianBasketFooter() {
  const pathname = usePathname();

  const noSpacePaths = [
    "/checkout",
    "/order-confirmation",
    "/login",
    "/signup",
    "/privacy-policy",
    "/terms",
    "/blog",
    "/accessibility",
    "/about-us",
    "/account",
  ];

  const isSpace = !noSpacePaths.some((path) => pathname?.startsWith(path));

  return (
    <footer className="asian-bucket-footer-main-wrapper custom-container">
      <section className="asian-bucket-newsletter-main-wrapper">
        <div className="asian-bucket-newsletter-icon">
          <img src="/assets/icons/mail.svg" alt="" />
        </div>
        <div>
          <h2>Stay in the Loop</h2>
          <p>
            Get weekly specials, new products and delicious recipes delivered to
            your inbox.
          </p>
        </div>
        <form onSubmit={(event) => event.preventDefault()}>
          <input
            type="email"
            placeholder="Enter your email address"
            aria-label="Email address"
          />
          <button type="submit">
            Subscribe <img src="/assets/icons/arrow-right.svg" alt="" />
          </button>
        </form>
      </section>

      <div className="asian-bucket-footer-content-main-wrapper">
        <div className="asian-bucket-footer-brand-main-wrapper">
          <Link href="/" className="asian-bucket-footer-logo-row">
            <img src="/assets/images/logo.jpg" alt="Asian Basket" />
            <span>
              <strong>Asian Basket</strong>
              <small>HOUSE OF INDIAN GROCERIES</small>
            </span>
          </Link>
          {/* <p className="asian-bucket-footer-tagline">
            More Than Groceries
            <br />A Taste of Home —
          </p> */}
          <p>
            Your neighbourhood Indian grocery store, bringing authentic
            products, fresh ingredients and great value to Windsor/Essex.
          </p>
        </div>

        <div className="asian-bucket-footer-column">
          <h3>Shop</h3>
          <Link href="/shop/groceries">All Groceries</Link>
          <Link href="/shop/fresh-food">Fresh Food</Link>
          <Link href="/shop/snacks-sweets">Snacks &amp; Sweets</Link>
          <Link href="/shop/take-out">Ready to Eat</Link>
          <Link href="/shop/personal-household">Personal &amp; Household</Link>
          <Link href="/shop/pooja">Pooja Items</Link>
        </div>
        <div className="asian-bucket-footer-column">
          <h3>Help &amp; Support</h3>
          <a href="/contact-us">Contact Us</a>
          <a href="/faq">FAQs</a>
          <a href="/faq">Account Help</a>
          {/* <a href="/faq">Track Your Order</a> */}
        </div>
        <div className="asian-bucket-footer-column">
          <h3>About Us</h3>
          <a href="/about-us">Our Story</a>
          {/* <a href="#">Community</a>
          <a href="#">Careers</a> */}
          <a href="/blog">Blog &amp; Recipes</a>
        </div>
        <div className="asian-bucket-footer-store-main-wrapper">
          <h3>Visit Our Store</h3>
          <p>
            <img src="/assets/icons/location.svg" alt="location" />
            <span>
              5189 Tecumseh Rd E<br />
              Windsor, ON N8T 1C3
              <br />
              <b>Get Directions →</b>
            </span>
          </p>
          <p>
            <img src="/assets/icons/location.svg" alt="phone" />{" "}
            <span>
              <b>(519) 555-7890</b>
              <br />
              Mon – Sun: 9:00 AM – 9:00 PM
            </span>
          </p>
          {/* <h3>We Accept</h3>
          <div className="asian-bucket-payment-badges">
            <img src="/assets/icons/visa-payment-icon.png" />
            <img src="/assets/icons/mastercard-payment-icon.png" />
            <img src="/assets/icons/american-express-payment-icon.png" />
            <img src="/assets/icons/interac-payment-icon.png" />
            <img src="/assets/icons/apple-pay-payment-icon.png" />
          </div> */}
        </div>
      </div>

      <div className="asian-bucket-service-strip-main-wrapper">
        <div>
          <img src="/assets/icons/leaf.svg" alt="" />
          <span>
            <strong>Fresh Quality</strong>
            <small>Produce and groceries you can trust</small>
          </span>
        </div>
        <div>
          <img src="/assets/icons/users.svg" alt="" />
          <span>
            <strong>Serving Our Community</strong>
            <small>Proudly serving families for over 20 years</small>
          </span>
        </div>
        <div>
          <img src="/assets/icons/truck.svg" alt="" />
          <span>
            <strong>Flexible Ordering</strong>
            <small>Pickup, local delivery or Uber Eats</small>
          </span>
        </div>
        <div>
          <img src="/assets/icons/headset.svg" alt="" />
          <span>
            <strong>Need Help?</strong>
            <small>We're here for you</small>
          </span>
        </div>
      </div>

      <div
        className={
          isSpace
            ? "asian-bucket-footer-bottom-main-wrapper is-space"
            : "asian-bucket-footer-bottom-main-wrapper"
        }
      >
        <span>© 2026 Asian Basket. All rights reserved.</span>
        <span>
          <a href="/privacy-policy"> Privacy Policy</a>
        </span>
        <span>
          <a href="/terms">Terms of Service</a>
        </span>
        <span>
          <a href="/accessibility">Accessibility</a>
        </span>
        <span className="asian-bucket-footer-bottom-spacer" />

        <div className="footer-bottom-follow-us-icon">
          <a
            href="http://facebook.com/p/Asian-Basket-61575095626395/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/icons/facebook.png" alt="facebook" />
          </a>

          <a
            href="https://www.instagram.com/asianbasketwindsor"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/icons/instagram.png" alt="Instagram" />
          </a>

          <a
            href="https://www.youtube.com/watch?v=h0w1GEE5qEk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/assets/icons/youtube.png" alt="youtube" />
          </a>
          {/* <img src="/assets/icons/ticktok.png" alt="facebook" /> */}
        </div>
      </div>
    </footer>
  );
}
